<style lang="scss"
       module>
.app {
  display: flex;
  flex-flow: column nowrap;
  min-height: 100vh;
}
</style>

<template>
  <div
    id="app"
    :class="$style.app">
    <AppHeader/>
    <router-view/>
    <AppFooter/>
  </div>
</template>


<script>
import AppFooter from '../layout/Layout.Footer.vue';
/* Vue Components */
import AppHeader from '../layout/Layout.Header.vue';
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'Layout',
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>
